import { Text } from 'dripsy';
import * as React from 'react';
export const FormControlHelperText = ({ id, children, }) => (React.createElement(Text, { nativeID: id, sx: { color: 'secondaryText', fontSize: '$0', fontWeight: 'medium', marginTop: '$2' } }, children));
FormControlHelperText.displayName = 'FormControlHelperText';
//# sourceMappingURL=FormControlHelperText.js.map